import React, { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

// img
import u1 from "../../../Assets/images/user.png";
import { Link } from "react-router-dom";
import Table from "../../../components/Common/Table";
import { toast, useToast } from "react-toastify";
import CustomPagination from "../../../components/Common/CustomPagination";
import { GET_ACCOUNTING_DATA } from "../../../services/ApiCalls";
import moment from "moment";
import { exportCsvHandler } from "../../../utilities/utilies";

const Accounting = () => {
  const [accountingData, setAccountingData] = useState([]);
  const [loader, setLoader] = useState();
  const [total, setTotal] = useState(0);
  const [dateFilter, setDateFilter] = useState({
    startDate: "",
    endDate: "",
  });
  const [body, setBody] = useState({
    page: 1,
    limit: 10,
    orderBy: "createdAt",
    order: -1,
    search: "",
  });

  const getAccountingData = async (body, dates) => {
    try {
      setLoader(true);
      const res = await GET_ACCOUNTING_DATA({ ...body, ...dates });
      if (res?.data?.status === "success") {
        setAccountingData(res?.data?.data?.transactions);
        setTotal(res?.data?.totalcount);
        setLoader(false);
      } else {
        toast.error(res?.data?.message);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      toast.error("something went wrong");
    }
  };

  const pageHandler = (page) => {
    const newBody = {
      ...body,
      page,
    };
    setBody(
      (p) => ({
        ...p,
        page,
      }),
      newBody
    );
    // setBody(newBody);

    getAccountingData(newBody);
  };

  useState(() => {
    getAccountingData(body);
  }, []);

  const searchHandler = () => {
    console.log(dateFilter);

    if (!dateFilter.startDate || !dateFilter.endDate) {
      return toast.error("please fill the dates to search");
    }

    if (
      moment(dateFilter.endDate).isSameOrBefore(moment(dateFilter.startDate))
    ) {
      return toast.error("from date should be less then to date");
    }

    getAccountingData(body, dateFilter);
  };
  const clearSearchHandler = () => {
    setDateFilter({
      startDate: "",
      endDate: "",
    });
    getAccountingData(body);
  };

  const col = [
    {
      label: "Sr no",
      id: "srNo",
      isComponent: true,
      component: (_, key) => (
        <p className={` m-0`}>{(body.page - 1) * body.limit + (key + 1)}</p>
      ),
    },
    {
      id: "description",
      label: "Booking Id",
      classNames: "text-muted",
      isComponent: true,
      component: (item) => (
        <p className={` m-0 fw-sbold text-primary`}>
          {item?.description.slice(17)}
        </p>
      ),
    },
    {
      label: "Time",
      id: "Time",
      isComponent: true,
      component: (item) => (
        <p className={` m-0 fw-sbold text-primary`}>
          {moment(item.date_created_utc).format("MM-DD-YYYY ,  HH:mm A")}
        </p>
      ),
    },
    {
      id: "type",
      label: "Type",
      // isComponent: true,
      // component: (item, index) => (
      //   <div>
      //     {item?.transactions?.map((transaction, index) => (
      //       <p key={index} className="m-0 fw-sbold text-primary">
      //         {transaction?.type}
      //       </p>
      //     ))}
      //   </div>
      // ),
    },
    {
      id: "amount",
      label: "Amount",
      classNames: "themeBlue fw-sbold",
      isComponent: true,
      component: (item) => (
        <p className={` m-0 fw-sbold text-primary`}>${item?.amount}</p>
      ),
    },
    {
      id: "balance",
      label: "Earning",
      classNames: "text-muted fw-sbold",
      isComponent: true,
      component: (item) => (
        <p className={` m-0 fw-sbold text-primary`}>${item?.balance}</p>
      ),
    },
    { id: "description", label: "Description", classNames: "text-muted" },

    // {
    //   label: "View",
    //   id: "",
    //   isComponent: true,
    //   component: (item) => (
    //     <div className="ActnBtn">
    //       <Link
    //         to={`/manage-booking/detail/${item._id}`}
    //         className="border-0 p-0"
    //         variant="transparent"
    //       >
    //         <svg
    //           xmlns="http://www.w3.org/2000/svg"
    //           width="18"
    //           height="18"
    //           viewBox="0 0 25 17"
    //           fill="none"
    //         >
    //           <path
    //             d="M24.8389 7.9541C22.8564 5.34668 20.8301 3.35937 18.8184 2.04102C16.7578 0.693359 14.6582 0.00488281 12.5684 0C12.5586 0 12.5488 0 12.5391 0C10.4443 0 8.3252 0.683594 6.25 2.03613C4.22363 3.34961 2.17285 5.3418 0.161133 7.94922C-0.0537109 8.23242 -0.0537109 8.62305 0.161133 8.90137C2.17285 11.5137 4.22363 13.5059 6.25 14.8193C8.33008 16.1719 10.4443 16.8555 12.5391 16.8555H12.5684C14.6582 16.8506 16.7627 16.1621 18.8184 14.8145C20.8301 13.4961 22.8516 11.5088 24.8389 8.90137C25.0537 8.62305 25.0537 8.23242 24.8389 7.9541ZM12.5635 15.293C12.5537 15.293 12.5439 15.293 12.5391 15.293C9.02832 15.293 5.40527 12.9834 1.77246 8.42773C5.40527 3.87207 9.02344 1.5625 12.5391 1.5625H12.5635C16.0645 1.57227 19.6533 3.88184 23.2275 8.42773C19.6533 12.9736 16.0693 15.2832 12.5635 15.293ZM12.5 3.54492C9.80957 3.54492 7.61719 5.73731 7.61719 8.42773C7.61719 11.1182 9.80957 13.3105 12.5 13.3105C15.1904 13.3105 17.3828 11.1182 17.3828 8.42773C17.3828 5.73731 15.1904 3.54492 12.5 3.54492ZM12.5 11.748C10.6689 11.748 9.17969 10.2588 9.17969 8.42773C9.17969 6.59668 10.6689 5.10742 12.5 5.10742C14.3311 5.10742 15.8203 6.59668 15.8203 8.42773C15.8203 10.2588 14.3311 11.748 12.5 11.748Z"
    //             fill="#666666"
    //           />
    //         </svg>
    //       </Link>
    //     </div>
    //   ),
    // },
  ];
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  // Calculate total pages
  const totalPages = Math.ceil(accountingData?.length / rowsPerPage);

  // Get current page data
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = accountingData?.slice(indexOfFirstRow, indexOfLastRow);

  const handlePrevious = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
    x;
  };
  return (
    <>
      <section className="accounting position-relative">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="TableFilter gap-10 mb-3 d-flex align-itmes-center justify-content-between flex-wrap">
                <div className="left"></div>
                {/* <div className="right d-flex align-items-end">
                  <Button
                    className="  d-inline-flex align-items-center   justify-content-center   commonBtn"
                    type="button"
                    onClick={() => exportCsvHandler("accounting")}
                  >
                    Export csv
                  </Button>
                </div> */}
              </div>
              <div className="table-responsive">
                <Table column={col} data={accountingData} loader={loader} />
                <div className="d-flex justify-content-end border-black">
                  <CustomPagination
                    current={body.page}
                    pageSize={body.limit}
                    total={total}
                    pageChangeHandler={pageHandler}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Accounting;
